<template>
  <!-- 顶部导航栏 -->
  <div>
    <div class="header">
      <van-nav-bar
        title="售后记录"
        left-arrow
        :fixed="true"
        :placeholder="true"
        @click-left="$router.go(-1)"
      />
    </div>
    <div v-for="item in List" :key="item.record_detail_id">
      <div
        class="commodity"
        v-for="serve in item.saleService"
        :key="serve.service_code"
      >
        <div class="serial processed">
          服务单号：{{ serve.service_code }}
          <span class="refund">{{ serve.turnoverList[0].title }}</span>
        </div>
        <div class="foot" @click="toRefundInfoOne(serve)">
          <div class="img">
            <img :src="item.color_img" alt="" />
          </div>
          <div class="text">
            <p class="p1">{{ item.goods_detail_name }}</p>
            <p class="p2">
              {{ item.color_name }}<span>X{{ serve.num }}</span>
            </p>
            <span class="p3">七天无理由退货</span>
          </div>
        </div>
        <div class="physical" @click.stop="getPlan(serve.service_code)">
          <p>
            {{ serve.turnoverList[0].service_desc }}
          </p>
        </div>
        <div class="btn">
          <van-button
            v-if="serve.status == 1"
            style="margin-left: 0.266667rem;"
            round
            color="#F74B2E"
            size="small"
            plain
            @click.stop="onClick(serve.service_id)"
            >取消申请</van-button
          >
          <van-button
            round
            plain
            size="small"
            color="#999999"
            @click.stop="toRefundInfoOne(serve)"
            >{{ serve.service_mode }}详细</van-button
          >
        </div>
      </div>
    </div>
    <div class="empty" v-if="this.extent == 0">
      <img src="../../assets/img/组 7417@2x.png" alt="" />
    </div>
  </div>
</template>
<script>
import { Dialog } from "vant";
export default {
  data() {
    return {
      List: [], //售后列表
      extent: 0, //售后列表条数
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let record_code = this.$route.query.record_code;
      this.$post({
        url: "/oor/findOmsOrderRecordInfo",
        method: "post",
        params: {
          userId: sessionStorage.getItem("EXCLUSIVE"),
          code: record_code,
        },
      }).then((res) => {
        this.extent = res.data.code[0].saleService.length;
        this.List = res.data.code[0].detailList;
      });
    },
    // 跳转到售后中详细
    toRefundInfoOne(item) {
      sessionStorage.setItem("orderCode", item.record_code);
      if ( item.status == 9) {
        this.$router.push({
          path: "/returnDetails",
          query: {
            service_code: item.service_id,
            orderCode: item.record_code,
          },
        });
      } else {
        this.$router.push({
          path: "/returnAudit",
          query: {
            service_code: item.service_id,
            orderCode: item.record_code,
          },
        });
      }
    },
    // 取消售后申请
    onClick(service_id) {
      Dialog.confirm({
        title: "取消申请",
        messageAlign: "left",
        message:
          "您将撤销本次申请，如您修改退货方式或退货商品，撤销申请后可重新发起申请，确认继续吗？",
      })
        .then(() => {
          this.$post({
            url: "/saleService/cancellation",
            method: "post",
            params: {
              service_id,
            },
          })
            .then((res) => {
              if (res.retCode == 200) {
                this.$toast("已取消");
                this.List = [];
                this.getList();
              } else {
                this.$toast(res.message);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          return false;
        });
    },
    // 跳转到进度详情
    getPlan(item) {
      this.$router.push({
        path: "/AfteProcessStatus",
        query: {
          service_code: item,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.header {
  /deep/.van-icon-arrow-left::before {
    font-size: 0.533333rem;
    color: black;
  }
  /deep/.van-nav-bar__title {
    font-weight: 600;
  }
}
.commodity {
  margin: 0 0.373333rem;
  background-color: #ffffff;
  margin-top: 0.266667rem;
  border-radius: 0.08rem;
  overflow: hidden;
  .serial {
    padding: 0.266667rem 0;
    margin: 0 0.4rem;
    font-size: 0.373333rem;
    font-family: PingFang SC;
    color: #333333;
    border-bottom: 0.026667rem solid #eeeeee;
  }
  .processed {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .refund {
      font-size: 0.373333rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #f74b2e;
    }
  }
  .foot {
    margin: 0.4rem;
    display: flex;
    align-items: center;
    .img {
      img {
        width: 2.053333rem;
        height: auto;
      }
    }
    .text {
      margin-left: 0.426667rem;
      .p1 {
        font-size: 0.426667rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
      }
      .p2 {
        width: 6rem;
        font-size: 0.32rem;
        font-family: PingFang SC;
        margin: 0.133333rem 0 0.266667rem 0;
        font-weight: 400;
        color: #666666;
        overflow: hidden;
        span {
          float: right;
        }
      }
      .p3 {
        font-size: 0.32rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: #f74b2e;
      }
    }
  }
  .physical {
    margin: 0.266667rem 0.266667rem;
    font-size: 0.32rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
    padding: 0.16rem 0.266667rem;
    background-color: #f0f0f0;
    border-radius: 0.133333rem;
  }
  .btn {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    margin: 0 0.4rem 0.24rem 0;
    /deep/.van-button--small {
      // height: 0.72rem;
      padding: 0.133333rem 0.32rem;
    }
    .btnText {
      margin-left: 0.4rem;
      display: flex;
      align-items: center;
      font-size: 0.32rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #666666;
      img {
        width: 0.373333rem;
        height: 0.373333rem;
      }
    }
  }
}
.empty {
  width: 10rem;
  overflow: hidden;
  text-align: center;
  img {
    margin-top: 4rem;
    width: 6.533333rem;
    height: auto;
  }
}
</style>
